import React from 'react';
import { Modal, Stack, Text, Loader, Center } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';

interface LogoutModalProps {
  opened: boolean;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({ opened }) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {}} // 閉じられないようにする
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      size="sm"
      transitionProps={{
        transition: 'fade',
        duration: 400,
        timingFunction: 'ease',
      }}
      overlayProps={{
        backgroundOpacity: 0.8,
        blur: 16,
      }}
      styles={{
        body: {
          padding: '2rem',
        },
        overlay: {
          backdropFilter: 'blur(16px)',
          transition: 'all 400ms ease',
        },
        content: {
          animation: 'fadeInScale 400ms ease forwards',
        },
        root: {
          '& .mantine-Modal-content': {
            animation: 'fadeInScale 400ms ease forwards',
          },
        },
      }}
    >
      <Stack align="center" gap="xl">
        <IconLogout size={48} color="var(--mantine-color-blue-6)" />

        <Stack align="center" gap="md">
          <Text size="lg" fw={600}>
            ログアウト処理中です
          </Text>
          <Text size="sm" c="dimmed">
            お疲れ様でした
          </Text>
        </Stack>

        <Center>
          <Loader size="md" type="dots" />
        </Center>
      </Stack>
    </Modal>
  );
};